module.exports = __webpack_public_path__ + "img/15@3x.299e319a.png";